import React, { useEffect, useRef, useState } from "react";
import "./RsvpSlideComponent.scss";

const RsvpSlideComponent = ({
  label = "Slide to RSVP →",
  to = "/rsvp",                 // where to navigate on success (use absolute or router-served path)
  onComplete,                   // optional: callback to run instead of navigation
  resetIfNotComplete = true,    // snap back if released early
}) => {
  const [val, setVal] = useState(0); // 0..100
  const [dragging, setDragging] = useState(false);
  const shellRef = useRef(null);

  // Navigate or callback
  const complete = () => {
    if (onComplete) {
      onComplete();
    } else if (to) {
      // simple, router-agnostic navigation
      window.location.assign(to);
    }
  };

  const handleChange = (e) => {
    const v = Math.max(0, Math.min(100, Number(e.target.value)));
    setVal(v);
  };

  const release = () => {
    setDragging(false);
    if (val >= 99) {
      complete();
    } else if (resetIfNotComplete) {
      setVal(0);
    }
  };

  // Keyboard support: allow End/Home to jump, arrows to move
  const onKeyDown = (e) => {
    if (e.key === "End") { setVal(100); e.preventDefault(); }
    if (e.key === "Home") { setVal(0); e.preventDefault(); }
  };

  return (
    <section className="rsvp" aria-label="RSVP Slider">
      <div className={`rsvp__shell ${val >= 99 ? "is-done" : ""}`} ref={shellRef} style={{ "--progress": `${val}%` }}>
        <div className="rsvp__fill" aria-hidden="true" />
        <input
          type="range"
          min={0}
          max={100}
          step={1}
          value={val}
          onChange={handleChange}
          onMouseDown={() => setDragging(true)}
          onTouchStart={() => setDragging(true)}
          onMouseUp={release}
          onTouchEnd={release}
          onKeyDown={onKeyDown}
          className="rsvp__range"
          aria-label="Slide to RSVP"
        />
        <div className="rsvp__label">
          {val >= 99 ? "Release to continue" : label}
        </div>
      </div>
      <p className="rsvp__hint">Slide fully to confirm your RSVP.</p>
    </section>
  );
};

export default RsvpSlideComponent;
